import { requestYfd, requestZgy } from './request'
import { stringify } from 'qs'
/**
 * 投递简历
 * @param {Object} body
 * @param {String} body.id
 * @param {String} body.isAccept
 * @param {String} body.userSrInfo
 */
export function offerfeedback(body) {
  return requestYfd(`/ep-garden-user-feedback/api/offer/feedback`, {
    method: 'POST',
    body,
  })
}

/**
 * 获取证件类型
 */
export function queryCredentialstype() {
  return requestZgy(`/ep-garden/submit_resume/credentialstype/info`, {
    method: 'GET',
  })
}

/**
 * 获取证件类型
 */
export function queryNationality() {
  return requestZgy(`/ep-garden/submit_resume/nationality/info`, {
    method: 'GET',
  })
}

/**
 * 检查候选人offer
 * @param {String} query.id
 */
export function checkOfferStatus(query) {
  const qs = stringify(query)
  return requestYfd(`/ep-garden-user-feedback/api/offer/check?${qs}`, {
    method: 'GET',
  })
}

/**
 * 获取候选人sr信息
 * @param {String} query.id
 */
export function querySrInfo(query) {
  const qs = stringify(query)
  return requestYfd(`/ep-garden-user-feedback/api/sr/info?${qs}`, {
    method: 'GET',
  })
}
